import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Calendar, MapPin, ExternalLink } from "lucide-react";
import { api } from "../lib/api";

export default function Events() {
  const [events, setEvents] = useState([]);
  useEffect(() => { api.get("/events").then(({ data }) => setEvents(data)).catch(() => {}); }, []);

  return (
    <div className="max-w-5xl mx-auto px-4 md:px-8 py-14">
      <p className="text-xs font-bold uppercase tracking-[0.3em] text-[#4A5D23] font-mono">Events</p>
      <h1 className="font-heading text-4xl md:text-5xl uppercase font-black tracking-tighter mt-2">Find Shodan Security</h1>
      <p className="text-black/60 mt-4 max-w-2xl">We attend gun shows, outdoor events, preparedness expos, local markets and community events across the region. Stop by the booth, handle the gear in person, and get show-only pricing.</p>
      <div className="mt-12 space-y-6">
        {events.map((event, i) => (
          <div key={event.id} data-testid={`event-card-${i}`} className={`border p-6 md:p-8 ${i === 0 ? "border-[#4A5D23] bg-[#4A5D23]/5" : "border-black/10 bg-white"}`}>
            {i === 0 && <span className="text-[10px] font-bold uppercase tracking-widest bg-[#4A5D23] text-white px-2 py-1">Next Event</span>}
            <div className="flex flex-col md:flex-row md:items-center gap-4 md:gap-8 mt-3">
              <div className="flex-1">
                <p className="text-[10px] font-bold uppercase tracking-widest text-black/40">{event.type}</p>
                <h2 className="font-heading text-xl md:text-2xl uppercase font-bold tracking-tight mt-1">{event.name}</h2>
                <div className="mt-3 space-y-1.5 text-sm text-black/70">
                  <p className="flex items-center gap-2"><Calendar size={14} className="text-[#4A5D23]" /> {event.date}{event.end_date !== event.date ? ` – ${event.end_date}` : ""}</p>
                  <p className="flex items-center gap-2"><MapPin size={14} className="text-[#4A5D23]" /> {event.location} · {event.booth}</p>
                </div>
                <p className="text-sm text-black/60 mt-3">{event.description}</p>
              </div>
              <div className="flex md:flex-col gap-3">
                <a data-testid={`event-map-${i}`} href={event.map_url} target="_blank" rel="noreferrer"
                  className="flex items-center justify-center gap-2 border border-black px-5 py-3 text-xs font-bold uppercase tracking-widest hover:bg-black hover:text-white transition-colors duration-150">
                  View Map <ExternalLink size={12} />
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-14 bg-[#121212] text-white p-8 md:p-12 text-center">
        <h2 className="font-heading text-2xl md:text-3xl uppercase font-bold tracking-tight">Can't Make the Show?</h2>
        <p className="text-white/60 text-sm mt-2">Everything at the booth is available online — shipped fast, straight to your door.</p>
        <Link data-testid="events-shop-online-btn" to="/shop" className="inline-block mt-6 bg-[#4A5D23] px-8 py-4 text-sm font-bold uppercase tracking-widest hover:bg-[#3D4D1D] transition-colors duration-150">Shop Online</Link>
      </div>
    </div>
  );
}
